<script>
    /**
     * Alert
     */
    export default {
        name: 'modal-header',
        props: {},
        methods: {},
        mounted () {}
    };
</script>

<template>
    <div class="normal-modal__hd">
        <strong class="normal-modal__title">
            <slot></slot>
        </strong>
    </div>
</template>

<style lang="less" scoped>

</style>
